import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { Meeting } from 'src/app/types';
import { verifyZDate2 } from 'src/utils/VerifyZDate';

@Injectable({
  providedIn: 'root',
})
export class MeetingService {
  constructor(private httpSv: HttpService, private uiSv: UiServices) {}

  async getAppointmentsByUser(params: { userId: number; pag: number }) {
    const res = await this.httpSv.itemIndex('meeting/index', '', params, '');
    return res;
  }

  async getAppointment(id: number) {
    return await this.httpSv.itemIndex(
      `meeting/show/${id}`,
      '',
      {
        id,
      },
      ''
    );
  }

  async deleteAppointment(id: number) {
    return await this.httpSv.itemAction({ id }, 'meeting', 'delete');
  }

  normalizeDate(
    appointment: Meeting,
    type: 'calendar' | 'timer',
    field: string,
    ev: string
  ) {
    if (type === 'calendar') {
      const currentDate = new Date(ev);
      appointment.date = `${currentDate.getDate()}/${
        currentDate.getMonth() + 1
      }/${currentDate.getFullYear()}`;
    }
    if (type === 'timer') {
      appointment[field] = new Date(ev).toISOString().split('T')[1];
      verifyZDate2(appointment);
    }
  }

  async saveAppointment(appointment: Meeting, userId: any) {
    try {
      appointment.userId = userId;
      console.log('appointment :>> ', appointment);
      for (const key in appointment) {
        const element = appointment[key];
        if (!element) {
          await this.uiSv.presentAlert(
            'Todos los campos son requeridos',
            false
          );
          return false;
        }
      }
      const action = appointment.id ? 'update' : 'store';
      const res = await this.httpSv.itemAction(appointment, 'meeting', action);

      if (res.status) {
        await this.uiSv.presentAlert('Cita guardada con exito');

        return true;
      }
    } catch (error) {
      console.error(error);
      this.uiSv.presentAlert(error.error.message);
    }
  }

  calcEndHour(appointment: Meeting, value: string, services: any[]) {
    const service = services.find(
      (service) => +service.id === +appointment.serviceId
    );
    const endHour = new Date();
    endHour.setHours(+value.split(':')[0]);
    endHour.setMinutes(+value.split(':')[1]);
    endHour.setMinutes(endHour.getMinutes() + +service.duration);
    appointment.endHour = endHour.toISOString().split('T')[1];
    appointment.duration = service.duration;
    verifyZDate2(appointment);
  }
}
